var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgShareSmall = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#E4DFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4896 7.5625C22.6497 7.5625 21.8443 7.89437 21.2504 8.48511C20.6565 9.07585 20.3229 9.87707 20.3229 10.7125C20.3236 10.9101 20.3429 11.1071 20.3806 11.3011L12.8701 15.659C12.2981 15.1769 11.5726 14.9124 10.8229 14.9125C9.98306 14.9125 9.17761 15.2444 8.58375 15.8351C7.98988 16.4259 7.65625 17.2271 7.65625 18.0625C7.65625 18.8979 7.98988 19.6991 8.58375 20.2899C9.17761 20.8806 9.98306 21.2125 10.8229 21.2125C11.5715 21.211 12.2953 20.9458 12.866 20.464L20.3806 24.8239C20.3429 25.0179 20.3236 25.2149 20.3229 25.4125C20.3229 26.2479 20.6565 27.0491 21.2504 27.6399C21.8443 28.2306 22.6497 28.5625 23.4896 28.5625C24.3294 28.5625 25.1349 28.2306 25.7288 27.6399C26.3226 27.0491 26.6562 26.2479 26.6562 25.4125C26.6562 24.5771 26.3226 23.7759 25.7288 23.1851C25.1349 22.5944 24.3294 22.2625 23.4896 22.2625C22.7403 22.2635 22.0157 22.5287 21.4444 23.011L13.9319 18.6511C13.9696 18.4571 13.9889 18.2601 13.9896 18.0625C13.9889 17.8649 13.9696 17.6679 13.9319 17.4739L21.4424 13.116C22.0144 13.5981 22.7399 13.8626 23.4896 13.8625C24.3294 13.8625 25.1349 13.5306 25.7288 12.9399C26.3226 12.3491 26.6562 11.5479 26.6562 10.7125C26.6562 9.87707 26.3226 9.07585 25.7288 8.48511C25.1349 7.89437 24.3294 7.5625 23.4896 7.5625Z",
    fill: "#7A69BF"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShareSmall, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/share_small.cf21571c.svg";
export { ForwardRef as ReactComponent };